import { useQuery } from "@tanstack/react-query";
import { neon } from "@/integrations/neon";
import { logError } from "@/utils/errors";
import { startSpan } from "@/utils/sentry";
import type { ScriptVersion } from "../types";

export const useScriptVersions = (scriptId: string | undefined) => {
  return useQuery({
    queryKey: ["script-versions", scriptId],
    enabled: Boolean(scriptId),
    staleTime: 60_000,
    queryFn: async (): Promise<ScriptVersion[]> => {
      if (!scriptId) throw new Error("Script ID is required");

      try {
        const data = await startSpan(
          {
            op: "neon.query",
            name: "script_versions.select",
            attributes: { scriptId },
          },
          async () => {
            return neon.api.versions.list(scriptId);
          }
        );

        return (data as unknown as ScriptVersion[]) ?? [];
      } catch (error) {
        logError(error, { feature: "versions", action: "fetchScriptVersions", scriptId });
        throw error;
      }
    },
  });
};
